import { sendMessage } from '../../../config/utils/message'
import { CORE_API_AKADEMIK } from '../../key/api'

// API GET METHOD
export async function getUser(nim) {
    try {
        const response = await CORE_API_AKADEMIK.get('pengajuankrs/data/view?nim=' + nim)
        return response
    }
    catch (err) {
        sendMessage(500)
    }
}

export async function getSemester(nim) {
    try {
        const response = await CORE_API_AKADEMIK.get('semester/dropdown?nim=' + nim)
        return response
    }
    catch (err) {
        sendMessage(err)
    }
}

export async function getOptPengajuan(smtta, semester, kdjur, kurikulum, angkatan, ta, nim) {
    const params = {
        smtta: smtta,
        kdjur: kdjur,
        kurikulum: kurikulum,
        angkatan: angkatan,
        ta: ta,
        nim: nim,
        semester: semester
    }

    try {
        const response = await CORE_API_AKADEMIK.get('pengajuankrs/krs', { params: params })
        return response
    }
    catch (err) {
        sendMessage(500)
    }
}

export async function getListPengajuan(nim, semester) {
    const params = {
        semester: semester,
        nim: nim
    }

    try {
        const response = await CORE_API_AKADEMIK.get('pengajuankrs/tabel/atas/view', { params: params })
        return response
    }
    catch (err) {
        sendMessage(500)
    }
}

export async function validasiKrs(idangkt, idjalur) {
    const params = {
        idangkt: idangkt,
        idjalur: idjalur
    }

    try {
        const response = await CORE_API_AKADEMIK.get('validasi/krs', { params: params })
        return response
    }
    catch (err) {
        sendMessage(500)
    }
}

// API POST METHOD
export async function AjukanKrs(data) {
    try {
        const response = await CORE_API_AKADEMIK.post('pengajuankrs/krs', data)
        return response
    }
    catch (err) {
        sendMessage(500)
    }
}

export async function setStatusKrs(idkrs, type = '') {
    try {
        const admin = localStorage.getItem("nim");
        const data = {
            ...idkrs,
            admin: admin
        }
        const response = await CORE_API_AKADEMIK.post(`pengajuankrs/${type}`, data)
        return response
    }
    catch (err) {
        sendMessage(500)
    }
}

// API PUT METHOD
export async function put() {
    try {
        const response = await CORE_API_AKADEMIK.put('')
        return response
    }
    catch (err) {
        sendMessage(500)
    }
}